

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OperatorModel } from '@/models/Operator';

const module = namespace('OperatorStore');

@Component
export default class OperatorCard extends Vue {
    @module.State private operators!: OperatorModel[];

    @Prop() private operator!: OperatorModel;

    get classByRarity() {
        return 'flex-box operator-card ' + 'rarity' + String(this.operator.rarity) + '-backcolor';
    }

    private getAllRole() {
        return new Set(this.operators.map((operator) => operator.role));
    }
}
